export default "__VITE_ASSET__s1WCmKSI__"